.overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  pointer-events: none;
}

.overlay.open {
  pointer-events: auto;
}

/* ---------------- BACKDROP ---------------- */

.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);

  opacity: 0;
  transition: opacity 240ms ease;
}

.overlay.open .backdrop {
  opacity: 1;
}

.overlay.closing .backdrop {
  opacity: 0;
}

/* ---------------- LAYOUT ---------------- */

.container {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.videoContainer {
  position: relative;
  width: 90%;
  height: 80%;

  transform: scale(0.92);
  opacity: 0;

  transition:
    transform 280ms cubic-bezier(0.22, 1, 0.36, 1),
    opacity 240ms ease;

  will-change: transform, opacity;
}

/* OPEN */
.overlay.open .videoContainer {
  transform: scale(1);
  opacity: 1;
}

/* CLOSE */
.overlay.closing .videoContainer {
  transform: scale(0.94);
  opacity: 0;
}

/* ---------------- VIDEO ---------------- */

.container video {
  width: 100%;
  height: 100%;
  max-height: none;
  border-radius: 16px;
  background: black;
  object-fit: cover;
}

/* ---------------- CLOSE BUTTON ---------------- */

.closeButton {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #ffa100;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  cursor: pointer;
  z-index: 3;
}

.closeIcon {
  width: 12px;
  height: 12px;
}

/* ---------------- DESKTOP (UNCHANGED) ---------------- */

@media (min-width: 900px) {
  .videoContainer {
    width: auto;
    height: auto;
  }

  .container video {
    width: min(90vw, 900px);
    max-height: 80vh;
    height: auto;
    border-radius: 12px;
    object-fit: contain;
  }
}
